import { FC } from 'react';
import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { OkrLabel } from '~src/store/okrs/interfaces';

const LabelElementWrapper = styled.div<{ isSelected?: boolean; isFixed: boolean }>`
  display: flex;
  height: 35px;
  width: auto;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  padding: 0 15px;
  cursor: ${({ isFixed }) => (isFixed ? 'normal' : 'pointer')};
  flex-shrink: 0;
  color: ${({ theme }) => theme.baseBlue.a10};
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.baseBlue.a0 : theme.baseBlue.a1)};
  &:hover {
    background-color: ${({ theme, isSelected, isFixed }) =>
      isSelected ? theme.baseBlue.a0 : isFixed ? theme.baseBlue.a1 : theme.baseBlue.a3};
  }
`;

const Title = styled.span.attrs({ className: 'caption_text' })``;

const LabelIcon = styled.div`
  margin-left: 10px;
`;

interface Props {
  type: 'add' | 'closed' | 'fixed';
  isSelected?: boolean;
  label?: OkrLabel;
  name?: string;
  add?: (label: OkrLabel) => void;
  create?: (name: string) => void;
  loading?: boolean;
}

const LabelElement: FC<Props> = props => {
  const click = () => {
    if (props.type === 'fixed') {
      return;
    }
    if (props.add && props.label) {
      props.add(props.label);
      return;
    }
    if (props.create && props.name) {
      props.create(props.name);
    }
  };

  return (
    <LabelElementWrapper isFixed={props.type === 'fixed'} isSelected={props.isSelected}>
      <Title>{props.label ? props.label.name : props.name}</Title>
      {props.type !== 'fixed' && (
        <LabelIcon onClick={click}>
          {props.loading ? (
            <LoadingSpinner size={8} />
          ) : (
            <SvgIcon
              width={props.type === 'add' ? 25 : 15}
              name={props.isSelected ? 'iconCheck' : props.type === 'add' ? 'iconPlus' : 'iconCrossInCircle'}
            />
          )}
        </LabelIcon>
      )}
    </LabelElementWrapper>
  );
};

export default LabelElement;
